import produce from 'immer';

const INITIAL_STATE = {
  data: [],
  loading: false
};

export default function productionLocalType(
  state = INITIAL_STATE,
  action: any
) {
  switch (action.type) {
    case '@productionLocalType/LIST_REQUEST':
      return produce(state, draft => {
        draft.loading = true;
      });

    case '@productionLocalType/LIST_SUCCESS':
      return produce(state, draft => {
        draft.loading = false;
        draft.data = action.payload.data;
      });

    case '@productionLocalType/LIST_FAILURE':
      return produce(state, draft => {
        draft.loading = false;
      });

    default:
      return state;
  }
}
